module.exports = __webpack_public_path__ + "img/78.803b16fe.svg";